module.exports = __webpack_public_path__ + "static/icon-nb-terrestre-cadb7b4a556803e59f5e37b190bbeed5.svg";